module.exports = __webpack_public_path__ + "epdf-app/dashboard/envelope/envelope-content-popup-1fAfTt1-.html";